module.exports = "/_next/static/images/BTPN-Logo-Primary-83336e8baef6043590c7472636342021.png";